import Trie from '../lib/trie'

const useTrie = (items=[], transform=(v) => (v)) => {
    const trie = new Trie(items, transform)
    return [trie]
}

export { useTrie }
